import { GridCellProps } from '@progress/kendo-react-grid';
import { useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import GridCellBase from '../GridCellBase';

function AttachmentIconCell(props: GridCellProps) {
  const [cellClick] = useContext(EditCellContext);
  const { onAttachmentClick } = cellClick?.(null);

  return (
    <GridCellBase {...props}>
      {!!props.dataItem?.receiptId && (
        <button
          className="center text-link cursor-pointer underline mx-auto"
          onClick={() => onAttachmentClick(props.dataItem)}
          title={props.dataItem.numOfAttachments}
        >
          {props.dataItem.numOfAttachments}
        </button>
      )}
    </GridCellBase>
  );
}

export default AttachmentIconCell;
